import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`


*{  
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: "Futura PT" !important;
    
    ::-webkit-scrollbar {
        width: 8px;
        background-color: ${({ theme }) => theme.colors.background_white};
        border-radius: 10px;
    }

    ::-webkit-scrollbar:horizontal {
        height: 5px;
    }

    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-horizontal {
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:horizontal {
        background-color: ${({ theme }) => theme.colors.tertiary_500};
        border-radius: 10px;
    }
}

html{
    overflow-x: hidden;

    .no-scroll {
        padding-right: 0 !important;
    }

    @media (max-width: 1080px){
        font-size: 93.75%;
    }

    @media (max-width: 720px){
        font-size: 87.5%;
    }

    body,p,h1,h2,h3{
        margin: 0;
    } 

    button{
        cursor:pointer;
        font-family: 'Futura PT'!important;
    }

    .displayNone{
        display: none;
    }
}

.dialogAlert{
    width: 35%;
    margin: auto;

    .headerDialog{
        padding: 1rem 1.5rem 2rem 1.5rem;    
    }

    .close{
        display: flex;
        justify-content: flex-end;

        button{
            border: none;
            color: ${({ theme }) => theme.colors.background_white};
            background:${({ theme }) => theme.colors.tertiary_500} ;
            border-radius: 1rem;
            cursor: pointer;
        }
    }

    .contentDialog{
        display: flex;
        align-content: center;
        width: 90%;
        gap: 0.5rem;

        svg{
            color: ${({ theme }) => theme.colors.secondary};
            align-items: center;
            font-size: 3rem;
        }

        h2{
            color: ${({ theme }) => theme.colors.secondary};
            font-size: 1rem;
            font-weight: lighter;
            margin:  0.5rem 0 0 0;
        }

        span{
            color: ${({ theme }) => theme.colors.secondary};
            font-size: 1rem;
            font-weight: bold;
        }
    }
}
    
.react-modal-overlay{
    background-color: rgba(0,0,0,0.3);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999 !important;
    display: flex;
    justify-content: center;
    align-items: center;
}
.react-error-overlay{
    background-color: rgba(0,0,0,0.3);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.react-collaborators-modal-content{
    width:100%;
    max-width: 50rem;
    background: ${({ theme }) => theme.colors.background_white};
    padding: 1.5rem;
    border-radius: 0.9rem;

    @media(max-width: 800px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
    }
}

.react-modal-content
{    
    width:100%;
    max-width: 533px;
    height: 200px;
    background: ${({ theme }) => theme.colors.background_white};
    padding: 2rem;
    position: relative;
    border-radius: 0.9rem;
    outline: none;

    @media(max-width: 800px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 2rem;
        min-width: 0;
    }
}

.react-create-list-contacts{
    width:100%;
    max-width: 20rem;
    height: 15rem;
    max-height: 12rem;
    background: ${({ theme }) => theme.colors.background_white};
    border-radius: 0.9rem;
    padding: 1rem;
}

.react-modal-event-details
{    
    width: 95%;
    max-width: 70rem;
    height: fit-content;
    background: ${({ theme }) => theme.colors.background_white};
    position: relative;
    border-radius: 0.9rem;
    outline: none;
}

.fieldError {
    padding-top: 0.2rem;
    color: red;
    display: flex;
    align-items: center;
    font-size: 1rem;
    flex-wrap: nowrap;

    svg {
      margin-right: 2px;
      font-size: 1rem;
      padding-bottom: 0.1rem;
    }
    @media(max-width: 550px){
        font-size: 0.75rem;
        svg{
            font-size: 0.75rem;
        }
    }
}

.react-delete-modal-content{
    max-width:35rem;
    width: 30rem;
    min-height: 12rem;
    background: ${({ theme }) => theme.colors.background_white};
    padding: 1.2rem 1.8rem;
    position: relative;
    border-radius: 1rem;

    @media(max-width: 660px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
        min-height: 0;
    }
}
.react-pendencies-modal-content{
    max-width:35rem;
    width: 30rem;
    min-height: 10rem;
    background: ${({ theme }) => theme.colors.background};
    padding: 1.2rem 1.8rem;
    position: relative;
    border-radius: 1rem;

    @media(max-width: 660px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
        min-height: 0;
    }
}

.react-term-conditions-content{
    max-width:35rem;
    width: 30rem;
    min-height: 10rem;
    background: ${({ theme }) => theme.colors.background};
    padding: 1.2rem 1.8rem;
    position: relative;
    border-radius: 1rem;


    @media(max-width: 660px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
        min-height: 0;
    }
}

.react-privacy-policy-modal-content{
    max-width:35rem;
    width: 30rem;
    min-height: 10rem;
    background: ${({ theme }) => theme.colors.background};
    padding: 1.2rem 1.8rem;
    position: relative;
    border-radius: 1rem;

    @media(max-width: 660px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
        min-height: 0;
    }
}

.react-edit-modal-content{
    width:100%;
    max-width: 600px;
    background: ${({ theme }) => theme.colors.background_white};
    padding: 1.5rem 1.8rem;
    position: relative;
    border-radius: 1rem;
  }
  
.react-alert-modal-content{
    @media(max-width: 660px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
        min-height: 0;
    }
}

.react-alert-modal-content{
    width:100%;
    max-width: 600px;
    min-height: 10%;
    background: ${({ theme }) => theme.colors.background_white};
    padding: 1.5rem 1.5rem;
    position: relative;
    border-radius: 1rem;

    @media(max-width: 560px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
    }
}

.suggestionModal-overlay{
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .suggestionModal-content{
        width: 340px;
        height: 208px;
        background-color: ${({ theme }) => theme.colors.background_white};
        padding: 0.8rem 0.8rem 0 1rem;
        border-radius: 17px;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
            
        .headerModal{
            display: flex;
            color: ${({ theme }) => theme.colors.secondary};
            font-size: 1.5rem;
            font-weight: bold;
            justify-content: space-between;
        }

        @media(max-width: 380px){
            width: 245px;
            height: 180px;
        }
    }
}

.contactUsModal-overlay{
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;

    .contactUsModal-content{
        width: 35rem;
        height: 18rem;
        background-color: ${({ theme }) => theme.colors.background_white};
        padding: 0.8rem 0.8rem 0 1rem;
        border-radius: 1rem;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
            
        .headerModal{
            display: flex;
            color: ${({ theme }) => theme.colors.secondary};
            font-size: 1.5rem;
            font-weight: bold;
            justify-content: space-between;
        }

        @media(max-width: 380px){
            width: 245px;
            height: 180px;
        }
    }
}

.react-delete-profile-modal-content{
    width:500px;
    max-width: 600px;
    max-height: 45rem;
    height: auto;
    background: ${({ theme }) => theme.colors.gray_200};
    padding: 0.5rem 1.5rem;
    position: relative;
    border-radius: 1rem;
    overflow-y:auto;

    @media(max-width: 560px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
    }
}

.react-add-modal-content{
    width: auto;
    min-width: 35rem;
    height: auto;
    padding: 1.6rem;
    position: relative;
    border-radius: 1rem;
    background: ${({ theme }) => theme.colors.background_white};

    @media(max-width: 450px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
    }
}

.react-view-accounts-modal-content{
    position: relative;
    border-radius: 1rem;
    padding: 0.5rem;
    background: ${({ theme }) => theme.colors.background};
    width: 80%;
    max-width: 40rem;
}
.react-view-presentation-modal-content{
    position: relative;
    border-radius: 1rem;
    padding: 0.5rem;
    background: ${({ theme }) => theme.colors.background};
    width: 80%;
    max-width: 40rem;
    h1{
        color: ${({ theme }) => theme.colors.secondary};
        font-size: 1.5rem;
    }
    .content{
        display: flex;
        flex-direction: column;
        gap: 1rem;
        margin-top: 1rem;
        padding: 0.5rem;
        
        p{
            color: ${({ theme }) => theme.colors.text};
        }
    }
}
.react-modal-feedback-form-content{
    width: 50rem;
    position: relative;
    border-radius: 1rem;
    padding: 1rem;
    background: ${({ theme }) => theme.colors.background_white};

    @media(max-width: 560px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
    }
}


.react-see-wallet-modal-content{
    width: 30rem;
    position: relative;
    border-radius: 1rem;
    padding: 1rem;
    background: ${({ theme }) => theme.colors.background_white};

    @media(max-width: 560px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
    }
}

.react-solicitation-modal-content{
    padding: 1.6rem;
    position: relative;
    border-radius: 1rem;
    width:700px;
    max-width: 700px;
    max-height: 30rem;
    overflow-y: auto;
    background: ${({ theme }) => theme.colors.background};
}

.react-chat-modal-content{
    max-width: 38rem;
    max-height: 25rem;
    min-width: 38rem;
    min-height: 23rem;
    background: ${({ theme }) => theme.colors.background_white};
    position: relative;
    border-radius: 1rem;
    padding: 1rem;

    @media(max-width: 560px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
    }
}

.react-status-payment-modal-content{
    width:700px;
    max-width: 700px;
    max-height: 30rem;
    height: auto;
    background: ${({ theme }) => theme.colors.gray_200};
    padding: 1.5rem 1.5rem 2rem 1.5rem;
    position: relative;
    border-radius: 1rem;
    overflow-y:auto;

    @media(max-width: 750px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
        min-height: 0;
    }
}
.react-finalize-demand-modal-content{
    width:45rem;
    max-width: 45rem;
    max-height: 30rem;
    height: auto;
    background: ${({ theme }) => theme.colors.gray_200};
    padding: 1.5rem;
    position: relative;
    border-radius: 1rem;
    overflow-y: auto;


    @media(max-width: 650px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
        min-height: 0;
    }
}
.react-cancel-solicitation-modal-content{
    width:500px;
    max-width: 500px;
    max-height: 30rem;
    height: auto;
    background: ${({ theme }) => theme.colors.gray_200};
    padding: 1.5rem;
    border-radius: 1rem;
    overflow-y:auto;
    @media(max-width: 500px){
        width: -webkit-fill-available;
        margin: 0 0.5rem;
        padding: 1rem;
        min-width: 0;
        min-height: 0;
    }
}

.google-map {
    .gm-style :last-child .gm-style-cc {
        display: none !important;
    }
}
`;
